<template>
  <el-dialog
    :title="robotName + this.$t('robotConfig.config')"
    :visible="true"
    :before-close="handleCancelConfig"
  >
  
    <el-form
      :model="ruleForm"
      label-width="100px"
      :rules="rules"
      ref="ruleForm"
    >
      <el-form-item :label="this.$t('robotConfig.exe')" prop="runType">
        <el-radio-group v-model="ruleForm.runType" size="medium">
          <el-radio :label="RUN_TYPE.INTERVAL">{{this.$t('robotConfig.by')}}</el-radio>
          <el-radio :label="RUN_TYPE.FIXED">{{this.$t('robotConfig.bytime')}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        :label="this.$t('robotConfig.time')"
        v-if="ruleForm.runType == RUN_TYPE.INTERVAL"
        prop="intervalValue"
        key="intervalValue"
      >
        <el-input-number
          v-model="ruleForm.intervalValue"
          :min="1"
          size="medium"
          style="width:130px"
        ></el-input-number>
        <el-select
          v-model="ruleForm.intervalUnit"
          placeholder="this.$t('robotConfig.unit')"
          style="width:100px;margin-left:6px;"
        >
          <el-option :label="this.$t('robotConfig.min')" :value="INTERVAL_UNIT.MINUTE"></el-option>
          <el-option :label="this.$t('robotConfig.hour')" :value="INTERVAL_UNIT.HOUR"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        :label="this.$t('robotConfig.day')"
        v-if="ruleForm.runType == RUN_TYPE.FIXED"
        prop="fixedTime"
        key="fixedTime"
      >
        <el-time-picker
          v-model="ruleForm.fixedTime"
          :arrow-control="true"
          :placeholder="this.$t('robotConfig.selecttime')"
          style="width:120px"
          :picker-options="{
            format: 'HH:mm'
          }"
          value-format="HH:mm"
        >
        </el-time-picker>
        <el-checkbox
          v-model="ruleForm.isIncludingWeekends"
          style="margin-left:15px"
          >{{this.$t('robotConfig.weekend')}}</el-checkbox
        >
      </el-form-item>
    </el-form>
    &nbsp;&nbsp;<span style="color:#bbb"><i class="el-icon-info"></i>&nbsp;{{this.$t('robotConfig.hint')}}&nbsp;{{robotName}}</span>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancelConfig">{{this.$t('common.cancel')}}</el-button>
      <el-button type="primary" @click="submitruleForm('ruleForm')"
        >{{this.$t('common.ok')}}</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { analysisCrontable, defaultCrontable } from "@/utils/robot/robot.js";
import { RUN_TYPE, INTERVAL_UNIT } from "@/constants/robot.js";
export default {
  props: {
    robotID: String,
    robotName: String,
    crontable: String,
    handleCancelConfig: Function,
    handleConfirmConfig: Function
  },
  name: "ConfigDialog",
  data: () => {
    return {
      RUN_TYPE: RUN_TYPE,
      INTERVAL_UNIT: INTERVAL_UNIT,
      ruleForm: defaultCrontable(),
      rules: {
        runType: [
          { required: true, message: "请选择执行方式", trigger: "blur" }
        ],
        intervalValue: [
          { required: true, message: "请输入间隔时间", trigger: "blur" }
        ],
        fixedTime: [
          { required: true, message: "请输入每日定时时间", trigger: "blur" }
        ]
      }
    };
  },
  mounted() {
    const crontableObject = analysisCrontable(this.crontable);
    this.ruleForm =
      crontableObject === null ? defaultCrontable() : crontableObject;
  },
  methods: {
    submitruleForm(ruleFormName) {
      this.$refs[ruleFormName].validate(valid => {
        if (valid) {
          this.handleConfirmConfig(this.ruleForm);
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style></style>
